import { useEffect, useState } from "react";
import config from "../../constants/config";
const { ENV_SUFIX } = config;

const CloudProxy = () => {
  const [gigyaLoaded, setGigyaLoaded] = useState(false);

  window?.tfIdentityGlobals?.showLoader();

  useEffect(() => {
    // Set referral URL cookie (expires in 1 hour)
    const referrerPage = document.referrer;
    sessionStorage.setItem("referrer_state", referrerPage);
    const expiry = new Date();
    expiry.setTime(new Date().getTime() + 1000 * 60 * 60); // 1 hour from now

    const cookieDomain = process.env[`REACT_APP_COOKIE_DOMAIN${ENV_SUFIX}`];
    document.cookie = `cip_referralURL=${window.location.href}; path=/; expires=${expiry.toUTCString()}; secure; domain=${cookieDomain}; SameSite=Strict`;

    // Delete cip_identifier cookie by setting past expiry
    document.cookie =
      `cip_identifier=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; Secure; domain=${cookieDomain}; SameSite=Strict`;
  }, []);

  useEffect(() => {
    // Get cookie function
    const getCookie = (name) => {
      const re = new RegExp(name + "=([^;]+)");
      const value = re.exec(document.cookie);
      return value != null ? unescape(value[1]) : null;
    };

    // Determine login link based on cookie
    const cip_ru = getCookie("cip_ru");
    const link =
      cip_ru === "true"
        ? "simplified-cloud-username.html"
        : "cloud-signin-identifier.html";

    // Load GIGYA SAML script dynamically
    const loadGigyaScript = () => {
      return new Promise((resolve, reject) => {
        // Check if script already exists
        const existingScript = document.querySelector(
          'script[src*="gigya.saml.js"]',
        );
        if (existingScript) {
          setGigyaLoaded(true);
          resolve();
          return;
        }

        const script = document.createElement("script");
        const cdcHostName = process.env[`REACT_APP_CDC_HOST_NAME${ENV_SUFIX}`];
        const cdcApiKey = process.env[`REACT_APP_CDC_API_KEY${ENV_SUFIX}`];
        script.src = `https://${cdcHostName}/js/gigya.saml.js?apiKey=${cdcApiKey}`;

        // Set the configuration as script content (matching the original HTML pattern)
        const config = {
          loginURL: link,
          logoutURL: "/account-center/saml-logout.html",
          errorURL:
            "/account-center/loginError.html?source=gigyajs-cloud-proxy",
        };

        // Set as both textContent and innerHTML for maximum compatibility
        const configString = JSON.stringify(config, null, 2);
        script.textContent = configString;

        script.onload = () => {
          window.gigyaJsLoaded = true;
          setGigyaLoaded(true);
          resolve();
        };

        script.onerror = (error) => {
          console.error("GIGYA SAML script failed to load:", error);
          // Redirect to error page if script fails to load
          window.location.href =
            "/account-center/loginError.html?source=gigyajs-cloud-proxy";
          reject(new Error("GIGYA SAML script failed to load"));
        };

        // Add script to head
        document.head.appendChild(script);
      });
    };

    loadGigyaScript().catch(console.error);

    // Cleanup function
    return () => {
      // Remove script if component unmounts
      const script = document.querySelector('script[src*="gigya.saml.js"]');
      if (script) {
        script.remove();
      }

      // Clean up global flag
      if (window.gigyaJsLoaded) {
        delete window.gigyaJsLoaded;
      }
    };
  }, []);

  // Show loading state while GIGYA loads
  if (!gigyaLoaded) {
    return;
  }

  return <div className="cloud-proxy">{}</div>;
};

export default CloudProxy;
